import React from 'react';
import ReactTable from 'react-table';
import { Checkbox, Icon } from 'semantic-ui-react';

import { CycleMenuRecipeFieldEnum as CycleMenuRecipeFields } from 'Common/FieldEnum';
import { PopupTextCell } from 'Common/GridHelper';

function FindResultsTable({ recipes, selectedRecipes, setSelectedRecipes }) {
  const hasAllChecked =
    recipes.length !== 0 &&
    Object.keys(selectedRecipes).length === recipes.length;

  const columns = React.useMemo(
    () => [
      {
        Header: (rows) => {
          return (
            <Checkbox
              checked={hasAllChecked}
              onChange={(e) => {
                if (hasAllChecked) {
                  setSelectedRecipes({});
                } else {
                  const newSelectedRecipes = {};
                  const ids = recipes.map(
                    (rec) => rec[CycleMenuRecipeFields.ShortId]
                  );
                  ids.forEach((id) => (newSelectedRecipes[id] = true));
                  setSelectedRecipes(newSelectedRecipes);
                }
              }}
            />
          );
        },
        id: 'Id',
        accessor: CycleMenuRecipeFields.ShortId,
        width: 32,
        Cell: ({ row, original }) => {
          if (original) {
            const shortId = original[CycleMenuRecipeFields.ShortId];
            return (
              <Checkbox
                checked={!!selectedRecipes[shortId]}
                onChange={(e) => {
                  if (selectedRecipes[shortId]) {
                    const newSelectedRecipes = { ...selectedRecipes };
                    delete newSelectedRecipes[shortId];
                    setSelectedRecipes(newSelectedRecipes);
                  } else {
                    const newSelectedRecipes = {
                      ...selectedRecipes,
                      [shortId]: true,
                    };
                    setSelectedRecipes(newSelectedRecipes);
                  }
                }}
              />
            );
          }
          return null;
        },
        resizable: false,
      },
      {
        Header: 'Id',
        accessor: CycleMenuRecipeFields.RecipeId,
        width: 100,
        resizable: false,
      },
      {
        Header: 'Name',

        accessor: CycleMenuRecipeFields.Name,
        resizable: false,
        Cell: (row) => <PopupTextCell text={row.value} />,
      },
      {
        Header: 'Day',
        resizable: false,
        accessor: CycleMenuRecipeFields.DayNumber,
        width: 110,
      },
      {
        Header: 'A La Carte',
        resizable: false,
        id: CycleMenuRecipeFields.Alacarte,
        accessor: (row) => {
          if (row[CycleMenuRecipeFields.Alacarte]) {
            return <Icon name="check" />;
          }
          return null;
        },
        style: {
          textAlign: 'center',
        },
        width: 80,
      },
    ],
    [recipes, selectedRecipes]
  );

  return (
    <ReactTable
      data={recipes}
      columns={columns}
      pageSize={5}
      minRows={5}
      showPageSizeOptions={false}
    />
  );
}

export { FindResultsTable };



// WEBPACK FOOTER //
// ./src/pages/managemenu/subpages/editmenu/components/FindResultsTable.js